import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { BiteDock } from "@/components/bite/BiteDock";
import { BiteHero } from "@/components/bite/BiteHero";
import { SocialFeed } from "@/components/bite/SocialFeed";
import { ExploreBites } from "@/components/bite/ExploreBites";
import { ReelsFeed } from "@/components/bite/ReelsFeed";
import { FoodBite } from "@/components/bite/FoodBite";
import { LearnBite } from "@/components/bite/LearnBite";
import { CareerBite } from "@/components/bite/CareerBite";
import { ShopBite } from "@/components/bite/ShopBite";
import { TravelBite } from "@/components/bite/TravelBite";
import { GreenBite } from "@/components/bite/GreenBite";
import { Communities } from "@/components/bite/Communities";
import { CreatorHub } from "@/components/bite/CreatorHub";
import { FUNZI } from "@/components/bite/BiteBot";
import { Partners } from "@/components/bite/Partners";
import { BiteInvestors } from "@/components/bite/BiteInvestors";
import { BiteDownload } from "@/components/bite/BiteDownload";
import { BiteFooter } from "@/components/bite/BiteFooter";

export default function StudyBite() {
  useEffect(() => {
    document.title = "FUNZ — The Gen Z Super App";
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div
      data-testid="funz-site"
      className="min-h-screen bg-[#09090B] text-white antialiased"
    >
        <div className="noise-overlay" aria-hidden="true" />
        <BiteDock />
        <main className="pb-24">
          <BiteHero />
          <SocialFeed />
          <ExploreBites />
          <ReelsFeed />
          <FoodBite />
          <LearnBite />
          <CareerBite />
          <ShopBite />
          <TravelBite />
          <GreenBite />
          <Communities />
          <CreatorHub />
          <FUNZI />
          <Partners />
          <BiteInvestors />
          <BiteDownload />
        </main>
        <BiteFooter />
        <Toaster theme="dark" position="top-center" />
    </div>
  );
}
